<h1 class="mt-2">People</h1>
<!-- <div class="green">Under development.</div> -->
<div class="d-flex flex-wrap mt-10">
	<div *ngFor="let personRole of persons" class="mb-10 mr-10">
		<metro-membership-person-info [person]="personRole.person"></metro-membership-person-info>
	</div>
</div>
